import Vue from 'vue'
import VueRouter from 'vue-router'


import { getLoginUrl, isAuthenticated, getToken } from '../utils/auth';

Vue.use(VueRouter)

import Container from "../views/Container.vue"
// import Login from "../views/Login.vue"

const routes = [
  { path: '/', component: Container, name: "Search" },
  // { path: '/login', component: Login, name: "Login" },

  { path: '/*', redirect: "/" },
]

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeResolve(async (to, from, next) => {
  const isLogged = await isAuthenticated(getToken(), window.location.origin);

  if (!isLogged) {
    window.localStorage.clear();
    window.location.href = getLoginUrl(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID);
    return next(false);
  }

  return next();
});



export default router
